import styled from '@emotion/styled';

export const StyledListItem = styled.li(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.grey40}`,
}));
